import * as signalR from '@microsoft/signalr';
import { API_URL } from '@/http';
import { ISearchDocResults } from '@models/search/ISearchDocResultItem';

class AISearchHub {
    private connection: signalR.HubConnection;
    private requestId: string = '';
    private onCompleteCallback: ((data: ISearchDocResults, success: boolean) => void) | null = null;

    constructor() {
        const logLevel = import.meta.env.PROD ? signalR.LogLevel.Warning : signalR.LogLevel.Trace;

        this.connection = new signalR.HubConnectionBuilder()
            .configureLogging(logLevel)
            .withUrl(`${API_URL}/aiSearchHub`)
            .build();
    }

    public async start(): Promise<void> {
        if (this.connection.state === signalR.HubConnectionState.Disconnected) {
            await this.connection.start();
        }
    }

    public stop(): void {
        if (this.connection.state === signalR.HubConnectionState.Connected) {
            this.connection.stop();
        }
    }

    public setRequestId(id: string): void {
        this.requestId = id;
    }

    public onComplete(callback: (data: ISearchDocResults, success: boolean) => void): void {
        this.cleanupListeners();
        this.onCompleteCallback = callback;

        this.connection.on('aiSearchCompleted', (id, data, success, message) => {
            if (id === this.requestId && this.onCompleteCallback) {
                this.cleanupListeners();
                this.onCompleteCallback(data, success);
                this.onCompleteCallback = null;
            }
        });
    }

    private cleanupListeners() {
        this.connection.off('aiSearchCompleted');
        this.requestId = '';
    }
}

export const aiSearchHub = new AISearchHub();
